module.exports = __webpack_public_path__ + "img/Group 427320407@2x.e179ed97.png";